<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row>
      <v-col cols="12" sm="12" lg="10">
        <div class="row d-block mt-5">
          <v-btn-toggle color="teal">
            <v-btn
              v-for="dir in viewButtons"
              :key="dir.name"
              @click="goToPage(dir.link)"
            >
              {{ dir.name }}
            </v-btn>
          </v-btn-toggle>
        </div>
        <router-view></router-view>
      </v-col>

      <v-col cols="12" sm="12" lg="10">
        <v-row>
          <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card
              color="info"
              icon="mdi-twitter"
              title="Customers"
              :value="counters.customers.count"
              sub-icon="mdi-clock"
              sub-text="Just Updated"
            />
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card
              color="primary"
              icon="mdi-poll"
              title="Service Reports"
              :value="counters.serviceReports.count"
              sub-icon="mdi-tag"
              sub-text="Just Updated"
            />
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card
              color="success"
              icon="mdi-store"
              title="Log Book"
              :value="counters.logBook.count"
              sub-icon="mdi-calendar"
              sub-text="Just Updated"
            />
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card
              color="orange"
              icon="mdi-sofa"
              title="Systems"
              :value="counters.systems.count"
              sub-icon="mdi-alert"
              sub-icon-color="red"
              sub-text="Just Updated"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { constants } from "../../constants";

export default {
  name: "HomeDashboard",
  methods: {
    goToPage(page) {
      this.$router.push(page);
    },
  },
  mounted() {
    Axios.get(constants.VUE_APP_BASEURL + "/counters")
    .then(({data}) =>{
      this.counters = data
    })
  },
  data: () => {
    return {
      counters: {},
      viewButtons: [
        {
          name: "Service Reports",
          link: "service-report",
        },
        {
          name: "Log Books",
          link: "log-book",
        },
        {
          name: "Customers",
          link: "customer",
        },
      ],
    };
  },
};
</script>

<style>
</style>